import { render, staticRenderFns } from "./VariantPricesComponent.vue?vue&type=template&id=02e51672"
import script from "./VariantPricesComponent.vue?vue&type=script&lang=js"
export * from "./VariantPricesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports